import { removeWhichCookies } from './remove-which-cookies'

export const sendLogoutRequest = async (fullUrl: string) => {
  try {
    await fetch('https://account.which.co.uk/api/sf/oauth2/slo', { method: 'GET' })
  } catch (error) {
    console.warn('SLO request failed', error)
  }

  if (typeof window !== 'undefined') {
    removeWhichCookies()
    window.location.href = fullUrl
  }
}
